require('../modules/esnext.promise.all-settled');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/promise-all-settled.js
// module id = f5Sx
// module chunks = 2